import React from "react";
import { ChallengeIconFunctionSVG, ChallengesLockFunction } from "./TaskLogo";
import { ChallengesInnerCardProps } from "../types/Challenges.type";
import Coin_Icon from '../../../../assets/images/coin-icon.svg';
import { toGlassColor } from "./ThemeManager";

const ChallengesInnerCard: React.FC<ChallengesInnerCardProps> = ({
  title,
  islockedIcon,
  metricCount,
  progressbarPercent,
  progressData,
  themeManager,
  completedActionIcon,
  incompletedActionIcon,
  xp,
  showCoin,
  completed,
  showCredits
}) => {
  const iconStyles: any = themeManager.getIconStyles();

  return (
    <div className="q_challenges_inner_card_main_cont">
      <div
        style={{ background: progressbarPercent ? toGlassColor(themeManager.getProgressBarColorStyles()) : toGlassColor("#EFEFEF",1) }}
        className="q_challenges_icon_main_cont"
      >
        {completed ? completedActionIcon || ChallengeIconFunctionSVG(iconStyles) : islockedIcon === "challengesIcon1"
          ? incompletedActionIcon || ChallengeIconFunctionSVG(iconStyles)
          : incompletedActionIcon || ChallengesLockFunction("")}
      </div>
      <div className="q_challenges_inner_card_name_cont">
        <div
          style={themeManager.getHeadingStyles()}
          className="q_challenges_inner_card_name_head"
        >
          {title}
        </div>
        <div className="q_challenges_inner_card_progressbar">
          <div
            style={{
              width: `${progressbarPercent}%`,
              background: themeManager.getProgressBarColorStyles(),
            }}
            className="q_challenges_inner_card_progressbar_inner"
          ></div>
        </div>
        <div
          style={themeManager.getPointsColorStyles(progressbarPercent)}
          className="q_challenges_inner_card_trips"
        >
          {progressbarPercent < 100
            ? `${Number(metricCount) - progressData} Points Left`
            : "Completed"}
        </div>
      </div>
      {showCoin && xp && xp > 0 && !completed ? (
        <div className="q_challenges_inner_card_points_cont">
          <img src={Coin_Icon} alt="coin" />
          <p className="q_challenges_inner_card_points">{xp}</p>
        </div>
      ) : null}

      {showCoin && xp && xp > 0 && completed ? (
        <div className="q_challenges_inner_card_completed_cont">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
            <path
              d="M8.07574 0.697209C8.36863 0.990102 8.36863 1.46498 8.07574 1.75787L4.07574 5.75787C3.78707 6.04655 3.32052 6.05131 3.02601 5.76858L1.02601 3.84858C0.727204 3.56172 0.717515 3.08695 1.00437 2.78814C1.29123 2.48933 1.766 2.47964 2.06481 2.7665L3.5347 4.17759L7.01508 0.697209C7.30797 0.404316 7.78285 0.404316 8.07574 0.697209Z"
              fill="#098849"
            />
          </svg>
        </div>
      ) : null}

      {showCredits && xp && xp > 0 && !completed ? (
        <p className="q_challenges_inner_card_credits">{xp} Credits</p>
      ) : null}

      {showCredits && xp && xp > 0 && completed ? (
        <div className="q_challenges_inner_card_credits_completed">
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
            <path d="M7.53033 0.46967C7.82322 0.762563 7.82322 1.23744 7.53033 1.53033L3.53033 5.53033C3.24166 5.81901 2.77511 5.82377 2.4806 5.54104L0.480602 3.62104C0.181794 3.33418 0.172104 2.85941 0.458961 2.5606C0.745817 2.26179 1.22059 2.2521 1.5194 2.53896L2.98929 3.95005L6.46967 0.46967C6.76256 0.176777 7.23744 0.176777 7.53033 0.46967Z" fill="#098849" />
          </svg>
          <p>Completed</p>
        </div>
      ) : null}
    </div>
  );
};

export default ChallengesInnerCard;
